import React from 'react';
import {Box, Grid, Typography} from '@mui/material';
import LoadingSpinnerIcon from '../../theme/styled-components/LoadingSpinnerIcon';

export const TYPOGRAPHY_MARGIN = 1.5;
const DetailPanelContentText: React.FC<{
  label: string;
  value?: string | number | null;
  loading?: boolean;
}> = ({label, value, loading = false}) => (
  <Grid item>
    <Typography margin={TYPOGRAPHY_MARGIN}>
      <b>{`${label}: `}</b>
      {value ||
        (loading ? (
          <Box display="inline-block">
            <LoadingSpinnerIcon />
          </Box>
        ) : (
          'N/A'
        ))}
    </Typography>
  </Grid>
);

export default DetailPanelContentText;
